<script lang="ts">
  import { Resizer } from "@opera-gx/components/v6";

  export let src: string;
  export let w: number;
  export let h: number;
  export let alt: string;

  let loading = true;

  const load = () => {
    loading = false;
  };
</script>

<style lang="postcss">
  .loading {
    opacity: 0;
  }

  img {
    transition: opacity 0.3s ease-in;
    opacity: 1;
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>

<Resizer {src} {w} {h} let:at1x let:at2x>
  {#if at1x && at2x}
    <slot
      {at2x}
      {at1x}
      bgImage="background-image: image-set(url({at1x}) 1x, url({at2x}) 1.2x);"
      srcset={`${at1x} 1x, ${at2x} 1.2x`}>
      <img
        on:load|once={load}
        class:loading
        class:fixed-ratio={!!w && !!h}
        draggable="false"
        srcset={`${at1x} 1x, ${at2x} 1.2x`}
        src={at1x}
        {alt} />
    </slot>
  {:else}
    <slot name="error">
      <!-- Some kind of placeholder -->
    </slot>
  {/if}
</Resizer>
